import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,{attrs:{"align":"center","justify":"center","no-gutters":""}},[_c(VCol,{attrs:{"md":"6"}},[_c('DashboardWelcome',{ref:"dashboardWelcome"})],1)],1),_c(VRow,[_c(VCol,[_c('DashboardOrganization')],1)],1),_c(VRow,[_c(VCol,[_c('DashboardReferral')],1)],1),_c(VRow,[_c(VCol,[_c('DashboardPlanning')],1)],1),_c(VRow,[_c(VCol,[_c('DashboardMemberships')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }